(() => {
  // Shopify lists a filter value only when the current collection offers it, so
  // a metafield filter carried in from another collection (collection-filter-links.js)
  // can empty the grid without a pill. Draw a pill for every filter.p.m.* value in
  // the URL that the header doesn't already show, linking to the URL without it.
  const pillTemplate = document.getElementById('filter-url-pill');
  const clearTemplate = document.getElementById('filter-url-pill-clear');
  if (!pillTemplate || !clearTemplate) return;

  let labels = {};
  try {
    labels = JSON.parse(document.getElementById('filter-url-pill-labels').textContent);
  } catch (error) {
    labels = {};
  }

  let scheduled = false;
  let observer = null;

  function urlWithout(key, value) {
    const url = new URL(window.location.href);
    const kept = url.searchParams.getAll(key).filter((item) => item !== value);
    url.searchParams.delete(key);
    url.searchParams.delete('page');
    kept.forEach((item) => url.searchParams.append(key, item));
    const search = url.searchParams.toString();
    return `${url.pathname}${search ? `?${search}` : ''}`;
  }

  function render() {
    const wrapper = document.querySelector('.filters-head .filters-header_active-wrapper');
    document.querySelectorAll('[data-filter-url-pill]').forEach((node) => node.remove());

    if (wrapper) {
      const shown = new Set(Array.from(wrapper.querySelectorAll('button-filter-remove[data-param]'))
        .map((node) => `${node.dataset.param}\n${node.dataset.value}`));
      const params = new URLSearchParams(window.location.search);
      const seen = new Set();
      const pills = [];

      params.forEach((value, key) => {
        const id = `${key}\n${value}`;
        if (!key.startsWith('filter.p.m.') || !value || shown.has(id) || seen.has(id)) return;
        seen.add(id);

        const pill = pillTemplate.content.firstElementChild.cloneNode(true);
        pill.setAttribute('href', urlWithout(key, value));
        pill.querySelector('[data-pill-label]').textContent = (labels[key] && labels[key][value]) || value;
        pills.push(pill);
      });

      if (pills.length) {
        let clearAll = wrapper.querySelector('.filters-form_remove-all');
        if (!clearAll) {
          // The template links to collection.url, which keeps ?q=<brand> on vendors and types.
          clearAll = clearTemplate.content.firstElementChild.cloneNode(true);
          wrapper.appendChild(clearAll);
        }
        pills.forEach((pill) => wrapper.insertBefore(pill, clearAll));
      }
    }

    // Drop the records for our own nodes; a swap that lands later still gets through.
    if (observer) observer.takeRecords();
  }

  function scheduleRender() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      render();
    });
  }

  // filters.js swaps the header first and pushes the new URL afterwards, so
  // render again on both and read the URL each time.
  ['pushState', 'replaceState'].forEach((method) => {
    const original = history[method];
    history[method] = function(...args) {
      const result = original.apply(this, args);
      scheduleRender();
      return result;
    };
  });
  window.addEventListener('popstate', scheduleRender);

  const grid = document.getElementById('filters-grid');
  // Only a new or changed header matters. Infinite scroll appends product cards
  // under the same grid, and redrawing then would drop keyboard focus on a pill.
  const touchesHead = (node) => node.nodeType === Node.ELEMENT_NODE
    && (node.matches('.filters-head') || node.querySelector('.filters-head') !== null);

  if (grid) {
    observer = new MutationObserver((records) => {
      const headChanged = records.some((record) => (record.target.closest && record.target.closest('.filters-head'))
        || Array.from(record.addedNodes).some(touchesHead)
        || Array.from(record.removedNodes).some(touchesHead));
      if (headChanged) scheduleRender();
    });
    observer.observe(grid, { childList: true, subtree: true });
  }

  render();
})();
